import React from 'react';
import { Button, Image } from 'react-bootstrap';
import { getInitials, getStatusIcon } from '../services/function';

import iconUserChat from '../assets/icon/userChat.svg';
import Users from '../interfaces/IUsers';
import UserDepartament from './UserDepartament';
import { userStatus } from '../enums/userStatus';

const UserChatGroup: React.FC<{
  users: Users[];
  addChat: (seqGrupo: number, seqUsuario: number) => void;
}> = ({ users, addChat }) => {
  return (
    <>
      {users
        .sort((a, b) => {
          if (a.status === b.status) {
            return a.nomeUsuario.localeCompare(b.nomeUsuario); // Ordena por nome se o status for igual
          }
          return a.status - b.status; // Ordena por status em ordem crescente
        })
        .map((user) => (
          <div
            key={user.seqUsuario}
            className=""
            style={{
              height: '7rem',
              width: '98%',
              borderRadius: '0.68rem',
              backgroundColor: '#e6e4e3',
              boxShadow: '0px 5px 3px -1px rgba(0, 0, 0, 0.25)',
            }}
          >
            <div
              style={{
                borderTopLeftRadius: '0.68rem',
                borderTopRightRadius: '0.68rem',
                borderColor: 'transparent',
                backgroundColor: '#1A1A1A',
                fontSize: '1.25rem',
                height: '2.5rem',
              }}
            >
              <div className="d-flex align-items-center justify-content-between me-1">
                <span
                  style={{
                    color: '#fff',
                    fontSize: '1.58rem',
                    marginLeft: '0.6rem',
                  }}
                >
                  {user.nomeUsuario}
                </span>
                <Button
                  className="p-0 m-0"
                  style={{ height: '2.1rem', width: '2.1rem' }}
                  onClick={() => addChat(0, user.seqUsuario)}
                >
                  <img
                    src={iconUserChat}
                    style={{ height: '1.8rem', width: '1.8rem' }}
                    alt="chat"
                  />
                </Button>
              </div>
            </div>
            <div className="d-flex position-relative">
              <div
                style={{
                  width: '4rem',
                  height: '4rem',
                  marginTop: '0.2rem',
                  marginLeft: '0.5rem',
                  backgroundColor:
                    user.cor === '' || !user.cor ? '#a3a3a3' : user.cor,
                  borderRadius: '0.6875rem',
                }}
                className="d-flex align-items-center justify-content-center"
              >
                <span
                  style={{
                    color: '#fff',
                    fontSize: '1.875rem',
                    textAlign: 'center',
                    fontWeight: '600',
                    wordWrap: 'break-word',
                  }}
                >
                  {getInitials(user.nomeUsuario)}
                </span>
              </div>
              {user.status !== userStatus.Invisivel && (
                <Image
                  className="position-absolute"
                  style={{
                    top: '3.2rem',
                    left: '3.8rem',
                    height: '1.4rem',
                    width: '1.4rem',
                  }}
                  src={getStatusIcon(user.status)}
                  alt="Online"
                />
              )}
              <div className="ms-2" style={{ width: '19.43rem' }}>
                <UserDepartament
                  userDepartament={user.departamento}
                  alignContent="justify-content-start"
                />
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default UserChatGroup;
